export enum PermissionLevel {
  FULL_ALL_BUSINESS_UNITS = 1,
  READ_ONLY_ALL_BUSINESS_UNITS = 4,
  NO_ACCESS = 6,
}
